import { FC } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { Icon } from '@sdb/planning-ui';
import type { IconType } from '@sdb/planning-ui/ui-3/packages/icons/__generated__';

interface NoDataPlaceholderProps {
  title?: string;
  icon?: IconType;
  height?: string | number;
}

const NoDataPlaceholder: FC<NoDataPlaceholderProps> = ({
  title,
  icon = 'chart-bar',
  height = 400
}) => {
  return (
    <Box
      height={height}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Stack spacing={2} justifyContent="center" alignItems="center">
        <Box mx="auto">
          <Icon type={icon} fontSize="large" />
        </Box>
        <Typography>{title}</Typography>
      </Stack>
    </Box>
  );
};

export default NoDataPlaceholder;
